export default __webpack_public_path__ + "static/media/heartcath.7f75c5f5.pdf";